import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

export const ReportsOutlet = () => {
  return (
    <Box>
      <Outlet />
    </Box>
  );
};
